import { Card } from '@yoweb/ui/components/containers';
import { Interactive } from '@yoweb/ui/components/typography';
import { ButtonIcon } from '@yoweb/ui/components/buttons';
import { AddIcon } from '@yoweb/ui/components/Icon/AddIcon';
import { CardButtonWrapper } from '@poplar/components/TaskTemplate/CardButtonWrapper';
import { truncateText } from '@yoweb/utils/truncateText';
import { Box } from '@yoweb/ui/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MAX_NAME_LENGTH = 65;
export var SubCategoryCard = function SubCategoryCard(_ref) {
  var card = _ref.card,
      onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(CardButtonWrapper, {
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(Card, {
      display: "flex",
      flexDirection: "row",
      height: 72,
      gap: "small4",
      p: "normal1",
      radii: "small",
      justifyContent: "space-between",
      alignItems: "center",
      "data-testid": "sub-category-card",
      children: [/*#__PURE__*/_jsx(Box, {
        width: "90%",
        children: /*#__PURE__*/_jsx(Interactive, {
          title: card.name,
          children: truncateText(card.name, MAX_NAME_LENGTH)
        })
      }), /*#__PURE__*/_jsx(ButtonIcon, {
        as: "span",
        mode: "dark",
        size: "sm",
        isFloating: false,
        icon: /*#__PURE__*/_jsx(AddIcon, {
          size: 12
        }),
        bgColor: "gingko"
      })]
    })
  });
};